import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import RechartsBarChart from "../../Chart";
import { server } from "../../common";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { useSelectAccess } from "../../store/stateFunctions";

const Dashoboard = () => {
  const user = useSelectAccess("Super Admin");
  const [data, setData] = useState([]);
  const [studentdata, setStudentData] = useState([]);
  const [industrydata, setIndustryData] = useState([]);

  useEffect(() => {
    getyuvasarathidata();
    getStudentdata();
    getIndustrydata();
  }, []);

  // Get
  const getyuvasarathidata = () => {
    server
      .get("/dashboard/dashboard", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };
  const getStudentdata = () => {
    server
      .get("/dashboard/studentdashboard", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setStudentData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };
  const getIndustrydata = () => {
    server
      .get("/dashboard/industrydashboard", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setIndustryData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };
  return (
    <>
      <div className="container fw-bold">
        <h4>Yuvasarthi</h4>
        <div className="row text-center p-3 gx-5">
          {data.map((item) => {
            return (
              <>
                <div className="col ">
                  <NavLink
                    to="/superadmin/postinternships"
                    className="p-3 border shadow-sm banner text-white card rounded-3 text-decoration-none"
                  >
                    <h5>{item.totalInternships}</h5> Total Internships
                  </NavLink>
                </div>
                <div className="col ">
                  <NavLink
                    to="/superadmin/postjobs"
                    className="p-3 border shadow-sm  banner text-white card rounded-3  text-decoration-none"
                  >
                    <h5>{item.totalJobs}</h5> Total Jobs
                  </NavLink>
                </div>
                <div className="col ">
                  <NavLink
                    to="/superadmin/addevents"
                    className="p-3 border shadow-sm  banner text-white card rounded-3 text-decoration-none"
                  >
                    <h5>{item.totalEvents}</h5> Total Events
                  </NavLink>
                </div>
                <div className="col ">
                  <NavLink
                    to="/superadmin/addmerchant"
                    className="p-3 border shadow-sm  banner text-white card rounded-3 text-decoration-none"
                  >
                    <h5>{item.totalMerchants}</h5> Merchants Businesses
                  </NavLink>
                </div>
              </>
            );
          })}
        </div>
      </div>

      {/* Students */}
      <div className="container fw-bold ">
        <h4>Citizens</h4>
        <div className="row text-center p-3 gx-5">
          {studentdata.map((item) => {
            return (
              <>
                <div className="col ">
                  <NavLink
                    to="/superadmin/students"
                    className="p-3 border shadow-sm  banner text-white card rounded-3  text-decoration-none"
                  >
                    <h5>{item.totalstudents}</h5> Total Registered Students
                  </NavLink>
                </div>
                <div className="col ">
                  <NavLink
                    to="/superadmin/totalinternshipapplications"
                    className="p-3 border shadow-sm  banner text-white card rounded-3  text-decoration-none"
                  >
                    <h5>{item.totalInternshipapplications}</h5> Total Internship
                    Applications
                  </NavLink>
                </div>
                <div className="col ">
                  <NavLink
                    to="/superadmin/totaljobapplications"
                    className="p-3 border shadow-sm  banner text-white  card rounded-3  text-decoration-none"
                  >
                    <h5>{item.totalJobs}</h5> Total Job Applications
                  </NavLink>
                </div>
              </>
            );
          })}
        </div>
      </div>

      {/* industry */}
      <div className="container fw-bold ">
        <h4>Industry</h4>
        {industrydata.map((item) => {
          return (
            <>
              <div className="row text-center p-3 gx-5">
                <div className="col ">
                  <NavLink
                    to="/superadmin/totalindustryusers"
                    className="p-3 border shadow-sm  banner text-white  card rounded-3  text-decoration-none"
                  >
                    <h5>{item.totalusers}</h5> Total Registered Users
                  </NavLink>
                </div>
                <div className="col ">
                  <NavLink
                    to="/superadmin/internshipsfromindustry"
                    className="p-3 border shadow-sm  banner text-white text-white card rounded-3  text-decoration-none"
                  >
                    <h5>{item.totalInternships}</h5> Total Internships
                  </NavLink>
                </div>
                <div className="col ">
                  <NavLink
                    to="/superadmin/jobsfromindustry"
                    className="p-3 border shadow-sm  banner text-white card rounded-3  text-decoration-none"
                  >
                    <h5>{item.totalJobs}</h5> Total Jobs
                  </NavLink>
                </div>
                <div className="col ">
                  <NavLink
                    to="/superadmin/eventsfromindustry"
                    className="p-3 border shadow-sm   card rounded-3  banner text-white text-decoration-none"
                  >
                    <h5>{item.totalevents}</h5> Total Events
                  </NavLink>
                </div>
              </div>

              <div className="row text-center  p-3  gx-5">
                <div className="col ">
                  <NavLink
                    to="/superadmin/newsfromindustry"
                    className="p-3 border shadow-sm  banner text-white card rounded-3 bg-warning text-decoration-none"
                  >
                    <h5>{item.totalnews}</h5> Upcoming News
                  </NavLink>
                </div>
                <div className="col ">
                  <NavLink
                    to="/superadmin/talksfromindustry"
                    className="p-3 border shadow-sm  banner text-white card rounded-3 bg-warning text-decoration-none"
                  >
                    <h5>{item.totaltalks}</h5> Total Talks
                  </NavLink>
                </div>
                <div className="col ">
                  <NavLink
                    to="/superadmin/podcastfromindustry"
                    className="p-3 border shadow-sm  banner text-white card rounded-3 bg-warning text-decoration-none"
                  >
                    <h5>{item.totalpodcasts}</h5> Total Podcasts
                  </NavLink>
                </div>
                <div className="col ">
                  <NavLink
                    to="/superadmin/blogsfromindustry"
                    className="p-3 border shadow-sm  banner text-white  card rounded-3 bg-warning text-decoration-none"
                  >
                    <h5>{item.totalblogs}</h5> Total Blogs
                  </NavLink>
                </div>
              </div>
            </>
          );
        })}

        <RechartsBarChart />
      </div>
    </>
  );
};

export default Dashoboard;
